import {
  AbstractType,
  Injectable,
  InjectionToken,
  Injector,
  Type,
} from '@angular/core';
import { Toast } from 'angular2-toaster';

import { INotificationToast } from '@app/containers/notifications/containers/notifications.container.types';
import { lazyInject } from '@app/containers/base/decorators';
import { XVII18nService } from './xvi-translate.service';
import { get, isFunction, isUndefined, omitBy } from 'lodash';

@Injectable()
export class NotificationI18nService {
  @lazyInject(XVII18nService)
  protected i18nService: XVII18nService;

  public constructor(protected injector: Injector) {}

  public inject<T>(
    token: Type<T> | InjectionToken<T> | AbstractType<T>,
    notFoundValue?: T,
  ): T {
    if (isFunction(this.injector.get)) {
      return this.injector?.get(token, notFoundValue);
    }

    return notFoundValue;
  }

  public translateNotification(notification: INotificationToast): Toast {
    return omitBy(
      {
        ...notification,
        title: this.tryToTranslateNotificationProps(notification, 'title'),
        body: this.tryToTranslateNotificationProps(notification, 'body'),
      },
      isUndefined,
    ) as Toast;
  }

  protected tryToTranslateNotificationProps(
    notification: INotificationToast,
    prop: 'title' | 'body',
  ): string {
    return this.i18nService.instant(get(notification, prop));
  }
}
